(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AvmPrequalificationDetailController', AvmPrequalificationDetailController);

    AvmPrequalificationDetailController.$inject = ['$uibModalInstance', 'entity', 'probe', 'mode'];

    function AvmPrequalificationDetailController($uibModalInstance, entity, probe, mode) {
        var vm = this;

        vm.probe = probe;
        vm.content = entity ? entity.content : null;
        vm.mode = mode; // 'client-request' | 'client-response' | 'request' | 'upstream-request' | 'raw-response'
        var titleKeys = {
            'client-request': 'avmPrequalifications.detail.clientRequestTitle',
            'client-response': 'avmPrequalifications.detail.clientResponseTitle',
            'request': 'avmPrequalifications.detail.requestTitle',
            'upstream-request': 'avmPrequalifications.detail.upstreamRequestTitle',
            'raw-response': 'avmPrequalifications.detail.rawResponseTitle'
        };
        vm.titleKey = titleKeys[mode] || 'avmPrequalifications.detail.rawResponseTitle';
        // An absent body arrives as "{}" (the server maps null/blank to it), which would read as "we
        // sent nothing" under a heading saying we did. Flagged per mode, not shared: a row can hold the
        // internal node while holding no vendor payload, so one alert covering both would claim a body is
        // missing that is right there.
        var isEmptyBody = (vm.content || '').trim() === '{}';
        vm.noRequestRecorded = mode === 'request' && isEmptyBody;
        vm.noUpstreamRequestRecorded = mode === 'upstream-request' && isEmptyBody;
        vm.noClientExchangeRecorded =
            (mode === 'client-request' || mode === 'client-response') && isEmptyBody;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
